'use client'

import { Elements } from '@stripe/react-stripe-js'
import { loadStripe, StripeElementsOptions } from '@stripe/stripe-js'

const stripePublishableKey = process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY
if (!stripePublishableKey) {
  throw new Error(
    'NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY is not defined in environment variables',
  )
}

const enableStripeDeveloperTools =
  process.env.NEXT_PUBLIC_STRIPE_ENABLE_DEVELOPER_TOOLS === 'true'

const stripePromise = loadStripe(stripePublishableKey, {
  developerTools: {
    assistant: {
      enabled: enableStripeDeveloperTools,
    },
  },
})

export default function StripeProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const options: StripeElementsOptions = {
    mode: 'setup',
    currency: 'usd',
    paymentMethodTypes: ['card'],
  }

  return (
    <Elements stripe={stripePromise} options={options}>
      {children}
    </Elements>
  )
}
